import axios from 'axios';
import {
  SET_FAMILY_MEMBERS,
  GET_FAMILY_MEMBERS,
  UPDATE_FAMILY_MEMBER,
  DELETE_FAMILY_MEMBER,
  FAMILY_MEMBERS_LOADING,
  FAMILY_MEMBERS_ERROR,
  CLEAR_FAMILY_MEMBERS,
  baseURL,
} from './types';

const getToken = () => localStorage.getItem('token');

export const setFamilyMembersLoading = () => ({
  type: FAMILY_MEMBERS_LOADING
});
export const clearFamilyMembers = () => ({
  type: CLEAR_FAMILY_MEMBERS
});

export const getFamilyMembers = (patientID) => async dispatch => {
  try {
    dispatch(setFamilyMembersLoading());
    const config = {
      headers: {
        'Authorization': `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      },
    };
    const res = await axios.post(`${baseURL}/api/appointmentPatientFamilyMembers/getall`,  patientID , config);
    dispatch({ type: GET_FAMILY_MEMBERS, payload: res.data });
  } catch (err) {
    dispatch({ type: FAMILY_MEMBERS_ERROR, payload: err.response?.data?.message || 'Error fetching family members' });
  }
};

export const setFamilyMembers = (membersData) => async dispatch => {
  try {
    dispatch(setFamilyMembersLoading());
    const token = getToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const responses = await Promise.all(
      membersData.map(memberData =>
        axios.post(`${baseURL}/api/appointmentPatientFamilyMembers/create`, memberData, config)
      )
    );
    const results = responses.map(r => r.data);
    dispatch({ type: SET_FAMILY_MEMBERS, payload: results });
    // Always return array, so frontend can process all
    return results;
  } catch (err) {
    const msg = err.response?.data?.message || 'Error adding family members';
    dispatch({ type: FAMILY_MEMBERS_ERROR, payload: msg });
    return [{ success: 0, message: msg }];
  }
};

export const updateFamilyMember = (memberData) => async dispatch => {
  try {
    dispatch(setFamilyMembersLoading());
    const token = getToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const res = await axios.patch(`${baseURL}/api/appointmentPatientFamilyMembers/update`, memberData, config);
    dispatch({ type: UPDATE_FAMILY_MEMBER, payload: res.data });
    return [res.data]; // ALWAYS return as array for uniform frontend processing
  } catch (err) {
    const msg = err.response?.data?.message || 'Error updating family member';
    dispatch({ type: FAMILY_MEMBERS_ERROR, payload: msg });
    return [{ success: 0, message: msg }];
  }
};

export const deleteFamilyMember = (memberData) => async dispatch => {
  try {
    dispatch(setFamilyMembersLoading());
    const token = getToken();
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: memberData
    };
    const res = await axios.delete(`${baseURL}/api/appointmentPatientFamilyMembers/delete`, config);
    dispatch({ type: DELETE_FAMILY_MEMBER });
    return [res.data]; // ALWAYS return as array for uniform frontend processing
  } catch (err) {
    const msg = err.response?.data?.message || 'Error deleting family member';
    dispatch({ type: FAMILY_MEMBERS_ERROR, payload: msg });
    return [{ success: 0, message: msg }];
  }
};
